import React from 'react';
import Chart from 'react-apexcharts';

const ResponseTimeChart = ({ data }) => {
    // Basic data for response time trend. For true P95/P99 we need the backend to supply it.
    // For now we plot average response time per day from trends.
    const options = {
        chart: { type: 'line', toolbar: { show: false } },
        xaxis: { categories: data.map(d => d.path || 'Unknown API') },
        yaxis: {
            labels: {
                formatter: function (val) {
                    return val ? val.toFixed(2) : "0";
                }
            }
        },
        tooltip: {
            x: {
                formatter: function(val, { dataPointIndex }) {
                    const req = data[dataPointIndex];
                    if (!req) return val;
                    const date = new Date(req.timestamp).toLocaleString();
                    return `${req.path} - ${date}`;
                }
            },
            y: {
                formatter: function (val) {
                    return val ? val.toFixed(2) + " ms" : "0 ms";
                }
            }
        },
        colors: ['#f39c12'],
        stroke: { curve: 'smooth', width: 3 },
        markers: { size: 4 }
    };

    const series = [{ name: 'Response Time (ms)', data: data.map(d => d.responseTime || 0) }];

    return (
        <div className="chart-card">
            <h3>API Response Time Trend</h3>
            <Chart options={options} series={series} type="line" height={300} />
        </div>
    );
};

export default ResponseTimeChart;
